import { Avatar, AvatarFallback, AvatarImage } from "~/components/ui/avatar";

export function RecentSales() {
  return (
    <div className="space-y-8">
      <div className="flex items-center">
        <Avatar className="h-9 w-9">
          <AvatarImage src="/avatars/01.png" alt="Avatar" />
          <AvatarFallback>AG</AvatarFallback>
        </Avatar>
        <div className="ml-4 space-y-1">
          <p className="text-sm font-medium leading-none">
            Alimentos Gutiérrez
          </p>
          <p className="text-sm text-muted-foreground">73.458.290-9</p>
        </div>
        <div className="ml-auto font-medium">+$1.999.990</div>
      </div>
      <div className="flex items-center">
        <Avatar className="h-9 w-9">
          <AvatarImage src="/avatars/02.png" alt="Avatar" />
          <AvatarFallback>DP</AvatarFallback>
        </Avatar>
        <div className="ml-4 space-y-1">
          <p className="text-sm font-medium leading-none">
            Distribuidora Pérez
          </p>
          <p className="text-sm text-muted-foreground">76.345.789-2</p>
        </div>
        <div className="ml-auto font-medium">+$3.876.500</div>
      </div>
      <div className="flex items-center">
        <Avatar className="h-9 w-9">
          <AvatarImage src="/avatars/03.png" alt="Avatar" />
          <AvatarFallback>RT</AvatarFallback>
        </Avatar>
        <div className="ml-4 space-y-1">
          <p className="text-sm font-medium leading-none">
            Restaurante Toscana
          </p>
          <p className="text-sm text-muted-foreground">77.234.567-8</p>
        </div>
        <div className="ml-auto font-medium">+$4.320.000</div>
      </div>
      <div className="flex items-center">
        <Avatar className="h-9 w-9">
          <AvatarImage src="/avatars/04.png" alt="Avatar" />
          <AvatarFallback>SM</AvatarFallback>
        </Avatar>
        <div className="ml-4 space-y-1">
          <p className="text-sm font-medium leading-none">
            Supermercado Metrópolis
          </p>
          <p className="text-sm text-muted-foreground">96.123.456-7</p>
        </div>
        <div className="ml-auto font-medium">+$12.650.000</div>
      </div>
      <div className="flex items-center">
        <Avatar className="h-9 w-9">
          <AvatarImage src="/avatars/05.png" alt="Avatar" />
          <AvatarFallback>HP</AvatarFallback>
        </Avatar>
        <div className="ml-4 space-y-1">
          <p className="text-sm font-medium leading-none">Hotel Provincial</p>
          <p className="text-sm text-muted-foreground">91.876.543-2</p>
        </div>
        <div className="ml-auto font-medium">+$8.250.000</div>
      </div>
    </div>
  );
}
